import { ReportsService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { reportsKeys } from 'app/queries/reports/reportsKeys';
import type { TCall } from 'app/queries/types/TCall';
import { buildJobsReportRequest } from './buildJobsReportRequest';

type TParams = QueryFunctionContext<ReturnType<typeof reportsKeys.workspaceJobsList>>;

export const createFetchJobsReportQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ workspaceId, params }], signal }: TParams) =>
    call(() => cancelOnSignal(ReportsService.getJobsReport(buildJobsReportRequest(workspaceId, params)), signal));
